import React, { useEffect, useState } from "react";
import styles from "./Login.module.css";

import DataLabLogo from "../../../assets/img/DataLabLogo.png";

import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { useDispatch, useSelector } from "react-redux";
import { authActions } from "../../../store/auth-store/auth-slice";
import { FloatLabel } from 'primereact/floatlabel';
import { SignIn, ValidateUser } from "../../../store/auth-store/auth-actions";
import { getTokenInfo } from "../../../utils/Guard";
import Loading from "../../../components/UI/loading/Loading";




const Login = () => {

  const userInfo = getTokenInfo();
  const auth = useSelector((state) => state.auth.auth);
  const dispatch = useDispatch();
  const notification = useSelector((state) => state.ui.notification);
  const [invalidField, setInvalidField] = useState("");
  const [filledInputs, setFilledInputs] = useState({
    name: false,
    lastName: false,
    email: false,
    password: false,
  });
  const [focused, setFocused] = useState({
    name: false,
    lastName: false,
    email: false,
    password: false,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (
      userInfo !== undefined &&
      userInfo !== null &&
      userInfo.id !== undefined &&
      userInfo.id !== null &&
      userInfo.id !== ""
    ) {
      window.location.href = "/";
    } else {
      setIsLoading(false);
    }
  }, [userInfo]);

  useEffect(() => {
    if (
      notification !== null && notification === undefined && notification.status !== undefined && notification.status !== null && notification.status === "success"
    ) {
      window.location.href = "/";
    } else {
      setIsLoading(false);
    }
  }, [userInfo, notification]);

  useEffect(() => {
    if (
      notification !== null &&
      notification !== undefined &&
      ((notification.status !== undefined &&
        notification.status !== null &&
        notification.status === "error") ||
        notification.status === "warning")
    ) {
      setTimeout(() => {
        setIsLoading(false);
      }, 500);
    }
  }, [notification]);

  const handleBlur = (field) => {
    setFocused((prev) => ({ ...prev, [field]: false }));
    setFilledInputs((prev) => ({ ...prev, [field]: prev[field] }));
  };

  const handleFocus = (field) => {
    setFocused((prev) => ({ ...prev, [field]: true }));
  };

  const onChangeHandler = (id, value) => {
    setFilledInputs((prev) => ({ ...prev, [id]: value.length > 0 }));
    dispatch(authActions.modifyPropertyValue({ id, value }));

    if (value !== "") {
      dispatch(authActions.setFieldValid({ id, value: true }));
    } else {
      dispatch(authActions.setFieldValid({ id, value: false }));
    }
  };
  
  const onSubmitHandler = () => {

    setInvalidField("");

    if (auth.email === "") {
      setInvalidField("email");
      return;
    } else if (auth.password === "") {
      setInvalidField("password");
      return;
    }

    dispatch(SignIn(auth));

    setIsLoading(true);
  };

  if (isLoading && (notification === null || notification === undefined)) {
    return <Loading />;
  }

  if (!isLoading || (notification !== null && notification !== undefined && notification.status !== undefined && notification.status !== null && notification.status !== "")) {

    return (
      <div className={`${styles.loginContainer} flex justify-content-center align-items-center`}>
        <div className={`${styles.loginCard} surface-card px-6 py-6 shadow-2 grid grid-nogutter`}>
          <div className={styles.loginFields}>
            <h2 className={`${styles.loginTitle} text-2xl`}>Iniciar sesión</h2>
            <div className="flex flex-column gap-3">
              <FloatLabel className={filledInputs.email || focused.email ? "mt-4" : "mt-0"}>
                <InputText
                  id="email"
                  name="email"
                  type="text"
                  label="Correo Electrónico"
                  value={auth.email}
                  onBlur={() => handleBlur("email")}
                  onFocus={() => handleFocus("email")}
                  onChange={(e) => onChangeHandler("email", e.target.value)}
                  className={styles.InputFields}
                  aria-describedby="email-help"
                />
                <label htmlFor="email" className={styles.InputFields}>Correo Electrónico</label>
              </FloatLabel>
              {invalidField === "email" && (
                <small id="email-help" className={`${styles.inputWarningText}`}>El campo email no puede estar vacío</small>
              )}
              <FloatLabel className={filledInputs.password || focused.password ? "mt-4" : "mt-0"}>
                <Password
                  id="password"
                  name="password"
                  label="Contraseña"
                  value={auth.password}
                  onBlur={() => handleBlur("password")}
                  onFocus={() => handleFocus("password")}
                  onChange={(e) => onChangeHandler("password", e.target.value)}
                  className={styles.InputFields}
                  feedback={false}
                />

                <label htmlFor="password" className={styles.InputFields}>Contraseña</label>
              </FloatLabel>

              {invalidField === "password" && (
                <small id="password-help" className={`${styles.inputWarningText}`}>El campo contraseña no puede estar vacío</small>
              )}
              <small id="username-help" onClick={() => window.location.href = "/forgot-password"} className={styles.registerButton}>¿Olvidaste tu contraseña?</small>
              <small id="username-help" onClick={() => window.location.href = "/register"} className={styles.registerButton}>¿No tienes una cuenta? Registrate</small>

              <Button onClick={() => onSubmitHandler()} label="Iniciar Sesión" type="submit" className={`${styles.loginButton} p-button-primary`} />
            </div>
          </div>
        </div>
        <div className={styles.logoContainer}>
          <img src={DataLabLogo} alt="PrimeReact Logo" className={`${styles.logo} mb-4`} />
        </div>
      </div>
    );
  }
};

export default Login;
